import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import ReactDatatable from "@ashvin27/react-datatable";
import { toastAlert } from "../../lib/toastAlert";
import envConfig from "../../lib/config"
import moment from 'moment';
import axios from 'axios';
import Exportexcel from "../pdf/Excelexport"
import Exportpdf from "../pdf/Exportpdf"
import Exportcsv from "../pdf/Exportcsv"
import { getcatorylist } from '../../actions/users';
import { useNavigate } from 'react-router-dom';

const CategoryList = () => {
    const navigate = useNavigate()
    const [userdet, setUser] = useState();
    const [exportdata, setExportdata] = useState([])

    useEffect(() => {
        getCatorylist();
    }, []);
    const getCatorylist = async () => {
        var req = {
          Collection: "Fractional"
        }
        var test = await getcatorylist(req);
        if (test.Success) {
          setUser(test.userValue);
          var ddd = test.userValue.map(({ _id, __v, id, image, deleted, show, label, value, createdAt, ...rest }) => {
    
            return rest
          })
          setExportdata(ddd)
    
        }
        else toastAlert('error', "Error on Server");
      };
    const hideshow = async (senddata) => {
        axios({
            method: "get",
            url: envConfig.API + "/admin/panel/category/hideshow",
            params: senddata
        }).then((data) => {
            toastAlert("success", "Category Status Changed Sucessfully");
            setTimeout(() => {
            window.location.reload();
            }, 4000);
        });
    };
    function editR(id) {
        if (id != "") {
          window.location.href = "/EditCategoryFractional/" + id;
        }
    }
    const Addcategory = async () => {
        navigate("/AddCategoryFractional");
    };
    const columns = [
    {
        key: "ind",
        text: "SNO",
        className: "name",
        align: "center",
        sortable: false,
        cell: (row, index, column, id) => <p className='text-center exchange_table_values'>{index + 1}</p>,
    },
    {
        key: "name",
        text: "name",
        className: "name",
        align: "center",
        sortable: false,
        cell: (record) => (
        <p className='text-center exchange_table_values'>Category</p>
        )
        
    },
    {
        key: "name",
        text: "Token Category",
        className: "Name",
        align: "center",
        sortable: false,
        cell: (record) => (
            <p className='text-center exchange_table_values'>{record.name}</p>
        )
    },
    {
        key: "image",
        text: "Category Image",
        className: "Name",
        align: "center",
        sortable: false,
        cell: (record) => (
        <div className='text-center exchange_table_values'>
            <img
            height={50}
            width={50}
            src={
                record.image == ""
                ? require("../../assets/images/loader.png")
                : envConfig.Back_Url +
                "/admin/category/" +
                record._id +
                "/" +
                record.image
            }
            />
        </div>
        ),
    },
    
    {
        key: "image",
        text: "Show on Home page",
        className: "Name",
        align: "center",
        sortable: false,
        cell: (record) => (
        <div className='text-center exchange_table_values'>
            <button
            className="primary_btn visibility"
            onClick={() => {
                var re = {
                _id: record._id,
                show: record.show,
                Collection: "Fractional"
                };
                hideshow(re);
            }}
            >
            {record.show == false ? <>Hide</> : <>Show</>}
            </button>
        </div>
        ),
    },
    
    {
        key: "createdAt",
        text: "Date",
        className: "Date",
        align: "center",
        sortable: false,
        cell: (record) => (
        <div className='text-center exchange_table_values'>
            <p>{moment(record.createdAt).format("MMMM,Do YYYY, hh:mm A")}</p>
        </div>
        ),
    },
    {
        key: "action",
        text: "Action",
        className: "action",
        width: 100,
        align: "center",
        sortable: false,
        cell: (record) => {
        return (
            <div className='text-center exchange_table_values'>
            <button
                className="btn btn-info btn-sm mr-1"
                onClick={() => editR(record.id)}
            >
                <i className="fa fa-edit"></i>
            </button>
            </div>
        );
        },
    },
    ];
    const config = {
        page_size: 5,
        length_menu: [10, 20, 50],
        filename: "Users",
        no_data_text: "No user found!",
    
        language: {
          length_menu: "Show _MENU_ result per page",
          filter: "Filter in records...",
          info: "Showing _START_ to _END_ of _TOTAL_ records",
          pagination: {
            first: "First",
            previous: <> Previous </>,
            next: <>Next</>,
            last: "Last",
          },
        },
        show_length_menu: true,
        show_filter: true,
        show_pagination: true,
        show_info: true,
        defaultSortAsc: true,
    };

    return (
        <>
            <Container fluid className="common_bg position-relative">
            <div className="liner"></div>
            <Row>
                <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                <Sidebar />
                </Col>
                <Col  xl={10} lg={12}>
                <Header title={'Category List'}/>
    
                <div className="common_page_scroller mt-5 pe-2">
                <div className="page_header">
            <h2>Category List</h2>
            <div>
                <div className="selection_sec">
                <button type='button' onClick={Addcategory}>ADD CATEGORY</button>
                </div>
    
            </div>
            </div>
                    <div className="exchange_table_holder dashboard_box rounded-3 mt-4">
                    <ReactDatatable
                        config={config}
                        records={userdet}
                        columns={columns}
                    />
                    </div>
                </div>
                <div className='bottom_btn_comp'>
        <Exportexcel excelData={exportdata} fileName={'category'} />
        <Exportpdf pdfData={exportdata} fileName={'category'} />
        <Exportcsv csvData={exportdata} fileName={'category'} />
        </div>
                </Col>
            </Row>
            </Container>
        </>
        )
}

export default CategoryList